/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S2_R4_IdentityInputs */

const tr_kvkkbasvuru_s2_r4_identity = /** @type {(inputs: Kvkkbasvuru_S2_R4_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel yetkili vekâletname aslı / onaylı sureti`)
};

const en_kvkkbasvuru_s2_r4_identity = /** @type {(inputs: Kvkkbasvuru_S2_R4_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original or certified copy of a special power of attorney`)
};

const de_kvkkbasvuru_s2_r4_identity = /** @type {(inputs: Kvkkbasvuru_S2_R4_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original oder beglaubigte Abschrift einer Sondervollmacht`)
};

const ru_kvkkbasvuru_s2_r4_identity = /** @type {(inputs: Kvkkbasvuru_S2_R4_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оригинал или заверенная копия специальной доверенности`)
};

/**
* | output |
* | --- |
* | "Original or certified copy of a special power of attorney" |
*
* @param {Kvkkbasvuru_S2_R4_IdentityInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s2_r4_identity = /** @type {((inputs?: Kvkkbasvuru_S2_R4_IdentityInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S2_R4_IdentityInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s2_r4_identity(inputs)
	if (locale === "de") return de_kvkkbasvuru_s2_r4_identity(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s2_r4_identity(inputs)
	return tr_kvkkbasvuru_s2_r4_identity(inputs)
});